module.exports = __webpack_public_path__ + "img/Automatikmont-MG-121.30b62322.jpg";